import React from "react";

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import SaveChanges from "./FlexiItemSaver";

//Icons
import SaveIcon from '@mui/icons-material/Save';
import PendingIcon from '@mui/icons-material/Pending';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import PrintIcon from '@mui/icons-material/Print';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

//Buttons
import Button from '@mui/material/Button';

//We'll reuse this statusbar, no big deal. 
import { StatusBar } from '../FlexiGrid/features/statusbar/StatusBar'
import {
	newStatus,
	incrementPass,
	incrementFail,
	setStatusTimeout
} from '../FlexiGrid/features/statusbar/statusbarSlice';
// import { Link } from 'react-router-dom';
// import Checkbox from "@mui/material/Checkbox"; // or wherever Checkbox comes from

// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';
// import Chip from '@mui/material/Chip';
// import dayjs from 'dayjs'; //Used with new datetimepickers
// //See if we can do without this, might already be wrapped . import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; //New adapter for mui x 7 datetime

// import FlexiGridAutoComplete from "./FlexiGridAutoComplete";
//Use these values for StatusBar
const menubtnstyle = {
	padding: { xs: "2px 4px 0px 4px", sm: "3px 4px 2px 4px", md: "5px 4px 3px 4px", lg: "5px 5px 2px 5px" },       // px (theme spacing units)
	fontSize: { xs: '0.75rem', sm: '0.9rem', md: '1rem' },
};

export default function FlexiItemTopMenu({
	localstate,
	UpdateState,
	classes,
	configuration,
	SetView,
	isChild,
	backlinktext,
	dispatch,
	history,
	perms
}) {

	if (configuration.topmenubar.render) {
		return (
			<div style={{ position: "sticky", top: "35px", backgroundColor: "#CCC" }}>
				<Grid container sx={{ width: "100%", display: "flex", flexGrow: "1", borderBottom: "2px solid #222", padding: "8px 0px 5px 0px", alignItems: "flex-start", }}> {/* set a height for the demo */}

					{/* LEFT SIDE, BACK BUTTON AND? */}
					{/* Back Button - When child of table and when not a child.*/}
					{(configuration.topmenubar.backbutton.render) &&
						<Grid size={{
							xs: 12,
							sm: 12,
							md: 12,
							lg: 2
						}}
						sx={{ textAlign: { xs: 'center', sm: 'center', md:'center', lg: 'left' } }}
						key={"backbtn"}>
							<div style={{ padding: "10px 2px 10px 8px" }}>
								{(isChild) &&
									<a style={{ cursor: "pointer", textDecoration: "underline", fontSize: "16px", color: "135cb0", textShadow: "1px 1px 1px #BBB" }} onClick={() => {
										//If we're dealing with a child relationship, we go back to the parent table, else render link.
										if (isChild) {
											SetView("grid", 0, localstate.reloadparenttable)
										}
									}}
									>
										&lt; {backlinktext}
									</a>
								}
								{(!isChild) &&
									<a style={{ cursor: "pointer", textDecoration: "underline", fontSize: "16px", color: "135cb0", textShadow: "1px 1px 1px #BBB" }} href={configuration.topmenubar.backbutton.nonchildlinkurl}>
										&lt; {configuration.topmenubar.backbutton.nonchildlinktext}
									</a>
								}
							</div>
						</Grid>
					}


					{/* RIGHT SIDE, BUTTONS AND STATUSBAR - Only renders when we're not flagging for a deletion.*/}
					{(localstate.itemdata.DeleteItem !== 1) &&
						<Grid size={{
							xs: 12,
							sm: 12,
							md: 12,
							lg: 10
						}}
							key={"rightside"}>
							{/* RIGHT SIDE GRID! Mostly setting 100% if xs on items */}
							<Grid container
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: {
										xs:"center",
										sm:"center",
										md:"center",
										lg:"flex-end",
									},
									alignItems: "flex-start",   // aligns children to the TOP>
								}}>

								{/* Save Button */}
								{(configuration.topmenubar.savebutton.render  && localstate.itemdata.SoftDelete!==1) &&
									<Grid
										size={{
											xs: 12,
											sm: "auto"
										}}
										sx={{
											marginRight:{
												xs:"10px",
												md:"5px"
											}
										}}
									>
										<Box className={classes.flexiitembtn}
											sx={{
												width: {
													xs: "100%",
													sm:"auto",
												},
											}}
											onClick={() => {
												if (localstate.pendingupdate) {
													SaveChanges(localstate, configuration, UpdateState, dispatch, history);
												}
											}}
										>
											<Box className={classes.flexiitembtninner}>
												<SaveIcon sx={{
													color: (localstate.pendingupdate ? "green" : "#222"),
													verticalAlign: "middle",
													display: "inline-block",
												}}>
												</SaveIcon>&nbsp;{configuration.topmenubar.savebutton.text}
											</Box>
										</Box>
									</Grid>
								}


								{/* Print Button */}
								{(configuration.topmenubar.printbutton.render && localstate.itemdata.SoftDelete!==1) &&
									<Grid
										size={{
											xs: 12,
											sm: "auto"
										}}
										sx={{
											marginRight:{
												xs:"10px",
												md:"5px"
											}
										}}
									>
										<Box className={classes.flexiitembtn}
											sx={{
												width: {
													xs: "100%",
													sm:"auto",
												},
											}}
											onClick={() => {
												if (!localstate.pendingupdate) { //Don't print some unsaved thing. In fact, probably dispatch an error!
													//SaveChanges(localstate, configuration, UpdateState, dispatch);
													//SomePrintFunction(....)
												}
											}}
										>
											<Box className={classes.flexiitembtninner}>
												<PrintIcon sx={{
													color: "#222",
													verticalAlign: "middle",
													display: "inline-block",
												}}>
												</PrintIcon>&nbsp;{configuration.topmenubar.printbutton.text}
											</Box>
										</Box>
									</Grid>
								}


								{/* Custom Buttons */}
								{configuration.topmenubar.custombuttons.map((custombutton, buttonindex)=>{
									if (custombutton.render){
										return(
											<Grid
											size={{
												xs: 12,
												sm: "auto"
											}}
											sx={{
												marginRight:{
													xs:"10px",
													md:"5px"
												}
											}}
										>
											<Box className={classes.flexiitembtn}
												sx={{
													width: {
														xs: "100%",
														sm:"auto",
													},
												}}
												onClick={() => {
													//Do something!
												}}
											>
												<Box className={classes.flexiitembtninner}>
													{custombutton.icon}&nbsp;{custombutton.text}
												</Box>
											</Box>
										</Grid>
										)
									}
									
								})}


								{/* Delete Button - Should not render if already deleted. */}
								{(configuration.topmenubar.deletebutton.render && localstate.itemdata.SoftDelete === 0 && perms.deletePerm) &&
									<Grid
										size={{
											xs: 12,
											sm: "auto"
										}}
										sx={{
											marginRight:{
												xs:"10px",
												md:"5px"
											}
										}}
									>
										<Box className={classes.flexiitembtn}
											sx={{
												width: {
													xs: "100%",
													sm:"auto",
												},
											}}
											onClick={() => {
												localstate.itemdata.DeleteItem = 1; //The API should always checks this. It then also understands to check perms server side.
												UpdateState(localstate);
											}}
										>
											<Box className={classes.flexiitembtninner}>
												<DeleteForeverIcon sx={{
													color: "#222",
													verticalAlign: "middle",
													display: "inline-block",
												}}>
												</DeleteForeverIcon>&nbsp;{configuration.topmenubar.deletebutton.text}
											</Box>
										</Box>
									</Grid>
								}

								{/* Un-Delete Button - Only for admins!*/}
								{(perms.admin && localstate.itemdata.SoftDelete === 1) &&
									<Grid
										size={{
											xs: 12,
											sm: "auto"
										}}
										sx={{
											marginRight:{
												xs:"10px",
												md:"5px"
											}
										}}
									>
										<Box className={classes.flexiitembtn}
											sx={{
												width: {
													xs: "100%",
													sm:"auto",
												},
											}}
											onClick={() => {
												localstate.itemdata.UndeleteItem = 1; //The API should always checks this. It then also understands to check perms server side.
												localstate.dbreload = true;
												localstate.itemloaded = false;
												SaveChanges(localstate, configuration, UpdateState, dispatch, history);
											}}
										>
											<Box className={classes.flexiitembtninner}>
												Undelete Record
											</Box>
										</Box>
									</Grid>
								}




								{/* Status Bar */}
								{(configuration.topmenubar.statusbar) &&
									<Grid
									size={{
										xs: 12,
										sm: 12,
										md: 12,
										lg:"auto",
									}}
									sx={{
										marginRight:{
											xs:"10px"
										},
										textAlign:{
											xs:"center",
											sm:"center",
											md:"center"
										}
									}}
								>
										{/* Status Bar */}
										<Box sx={{
											display: "inline-flex",
											flexGrow: 1,
											width:{
												xs: "100%",
												sm: "100%",
												md: "100%",
											},
											minWidth: {
												md: "220px",
												lg: "220px",
												xl: "220px"
											},
											maxWidth: {
												xs: "100%",
												sm: "100%",
												md: "100%",
												lg: "270px",
												xl: "270px"
											},
										}}>
											<Box sx={{
												height: {
													xs: "30px",
													sm: "30px",
													md: "35px",
													lg: "35px"
												},
												width: "100%",
												backgroundColor: "#AAA",
												marginTop: "5px",
												marginRight: "4px",
												marginLeft: "15px",
											}}>
												<StatusBar />
											</Box>
										</Box>
									</Grid>
								}
							</Grid>
						</Grid>
					}

					{/* RIGHT SIDE, DELETION CONFIRMATION MESSAGE */}
					{(localstate.itemdata.DeleteItem === 1) &&
						<Grid size={{
							xs: 12,
							sm: 12,
							md: 12,
							lg: 10
						}}
							key={"rightside"}>
								<div style={{ textAlign: "right", padding: "0px 2px 0px 8px", fontSize:"22px", fontFamily:"Inter" }}>
									{configuration.topmenubar.deletebutton.confirmationtext} 
									<Box className={classes.flexiitembtn}
											sx={{
												width: {
													xs: "100%",
													sm:"auto",
												},
											}}
											onClick={() => {
												SaveChanges(localstate, configuration, UpdateState, dispatch, history);
											}}
										>
											<Box className={classes.flexiitembtninner}>
												<DeleteForeverIcon sx={{
													color: "#222",
													verticalAlign: "middle",
													display: "inline-block",
												}}>
												</DeleteForeverIcon>&nbsp;Yes
											</Box>
										</Box>
										<Box className={classes.flexiitembtn}
											sx={{
												width: {
													xs: "100%",
													sm:"auto",
												},
											}}
											onClick={() => {
												localstate.itemdata.DeleteItem = 0; //The API should always checks this. It then also understands to check perms server side.
												UpdateState(localstate);
											}}
										>
											<Box className={classes.flexiitembtninner}>
												Cancel
											</Box>
										</Box>
										</div>


						</Grid>
					}
				</Grid>





			</div>



		)
	}

}
// export default function FlexiRow({
// 	index,
// 	row,
// 	rowRefs,
// 	localstate,
// 	UpdateState,
// 	classes,
// 	configuration,
// 	defaultChecked,
// 	HandleKeyDown,
// 	onChangeValue, //To DO, pull into this controller.\
// 	onChangeAutoCompleteValue,
// 	SelectRow,
// 	ExpandRowToggle,
// 	editmode,
// 	ResetKeys
// }) {

// 	//ATTEMPT TO MOVE THIS TO THE PARENT UNDER A USEEFFECT: CREATE REFS ONCE.
// 	//   // Side effect to create refs
// 	//   React.useEffect(() => {
// 	//     rowRefs.current[index + "SaveStatus"] = React.createRef();
// 	//     configuration.columns.forEach((column) => {
// 	//       if (column.editable && editmode) {
// 	//         rowRefs.current[index + column.field] = React.createRef();
// 	//       }
// 	//     });
// 	// 	console.log(column.field);
// 	//   }, [index, configuration.columns, rowRefs]);

// 	//   console.log("#################");
// 	//   console.log(configuration)

// 	//   //Construct an array of "currentcolumns" to speed up our processing of column configurations

// 	const currentcolumns = React.useMemo(() => {
// 		return configuration.columns.filter(col => col.visible);
// 	}, [configuration.columns]);


// 	//   var i=0;
// 	//   const currentcolumns = [
// 	// 	configuration.columns.map((column, columnindex)=>{
// 	// 		if (column.visible){
// 	// 			//Add to our array of currentcolumns
// 	// 			return column;
// 	// 			i++;
// 	// 		}
// 	// 	})
// 	//   ];
// 	//   console.log(currentcolumns);

// 	//Compute container border style
// 	const createborderstyle = (column) => {
// 		if (column.borders === "all") {
// 			//However! We might want to disable our own right or left border based on another column's preference.
// 			return { border: "1px solid #BBB", textAlign: column.valuetextalign };
// 		}
// 		if (column.borders === "noright") {
// 			return { border: "1px solid #BBB", borderWidth: "1px 0px 1px 1px", textAlign: column.valuetextalign };
// 		}
// 		if (column.borders === "noleft") {
// 			return { border: "1px solid #BBB", borderWidth: "1px 1px 1px 0px", textAlign: column.valuetextalign };
// 		}
// 		if (column.borders === "noleftorright") {
// 			return { border: "solid #BBB", borderWidth: "1px 0px 1px 0px", textAlign: column.valuetextalign };
// 		}




// 		return {};

// 	}

// 	function getByPath(obj, path) {
// 		if (obj == null) return undefined;
// 		return path.split('.').reduce((acc, key) => {
// 			return (acc == null) ? undefined : acc[key];
// 		}, obj);
// 	}



// 	const DetectBlankNumber = (event, index, column) => {
// 		if (event.target.value === "") {
// 			rowRefs.current[index + column.field].value = "0.00";
// 			localstate.griditems[index][column.field] = "0.00";
// 		}
// 	}




// 	return (
// 		<>
// 			{configuration.columns.map((column, columnindex) => {



// 				{/* ##### MAIN CHECKBOX ##### */ }
// 				if (column.render === "maincheckbox" && column.visible) {
// 					return (
// 						<td
// 							key={"I" + index + "C" + columnindex}
// 							style={column.cellstyle} //Calculated in parent
// 							ref={el => (rowRefs.current[index + "SaveStatus"] = el)}
// 						>
// 							<div style={{ padding: "1px 4px 1px 4px" }}>
// 								<Checkbox
// 									key={row.GridKey}
// 									//Trying: (seems to work! 1/28/2026) inputRef={el => (rowRefs.current[index + "Checkbox"] = el)}
// 									slotProps={{ input: {ref: el => (rowRefs.current[index + "Checkbox"] = el)} }}
// 									className={classes.gridcheckbox}
// 									color="default"
// 									checked={localstate.griditems[index].isSelected}
// 									checkedIcon={<span className={classes.icon + " " + classes.checkedIcon} />}
// 									icon={<span className={classes.icon} />}
// 									onKeyDown={event => HandleKeyDown(event, index, column)}
// 									onChange={() => SelectRow(index)}
// 								/>
// 							</div>
// 						</td>
// 					);
// 				}

// 				{/* ##### TEXT ##### */ }
// 				{/* Boolean, true or false. */}
// 				if (column.render === "text" && column.visible) {

// 					{/* ### Non-editable ### 
// 							Note: Checking for editable is silly, we allow that to be checked earlier before we establish currentlyeditable. You can even default them as true.
// 					*/}
// 					if (!editmode || (!column.editable && !column.requiresref)) {
// 						return (
// 							<td
// 								key={"I" + index + "C" + columnindex}
// 								style={column.cellstyle}
// 								className={classes.flexigridtextcontainer}
// 							>
// 								{getByPath(localstate.griditems[index], column.field)}
// 							</td>
// 						);
// 					}

// 					{/* This is a non-editable value that might change when other values change. Has ref! */}
// 					if (editmode && (!column.editable && column.requiresref)) {
// 						return (
// 							<td
// 								key={"I" + index + "C" + columnindex}
// 								style={column.cellstyle}
// 								className={classes.flexigridtextcontainer}
// 							>
// 								<span ref={el => rowRefs.current[index + column.field] = el}>
// 									{localstate.griditems[index][column.field]}
// 								</span>
// 							</td>
// 						);
// 					}
// 					{/* Text editable */}
// 					if (editmode && column.editable) {
// 						return (
// 							<td
// 								key={"I" + index + "C" + columnindex}
// 								style={column.cellstyle}
// 								className={classes.flexigridinputcontainer}>
// 								<input
// 									ref={el => rowRefs.current[index + column.field] = el}
// 									className={classes.flexgridinput}
// 									style={{ minWidth: '50px', textAlign: "left" }}
// 									onKeyDown={(event) => HandleKeyDown(event, index, column)}
// 									onKeyUp={(event) => onChangeValue(event, index, column)}
// 									defaultValue={localstate.defaultvalues[index][column.field]} />
// 							</td>

// 						);
// 					}
// 				}


// 				{/* ##### TEXTLINK ##### */ }
// 				if (column.render === "textlink" && column.visible) {
// 					return (
// 						<td
// 							key={"I" + index + "C" + columnindex}
// 							style={column.cellstyle}
// 							className={classes.flexigridtextcontainer}
// 						>
// 							<div className={classes.truncatedtextcontainer}>
// 								<div className={classes.truncatedtext}>
// 									<Link
// 										sx={{ color: "#000" }}
// 										to={{
// 											pathname: column.linkendpoint + localstate.griditems[index][column.linkid],
// 										}}
// 										target={column.target}
// 									>

// 										{(localstate.griditems[index][column.field] !== "") &&
// 											<b>{localstate.griditems[index][column.field]}</b>
// 										}
// 										{(localstate.griditems[index][column.field] === "") &&
// 											<b>(missing)</b>
// 										}
// 									</Link>
// 								</div>
// 							</div>
// 						</td>
// 					)
// 				} 


// 				{/* ##### NUMBER ##### */ }
// 				if (column.render === "number" && column.visible) {
// 					if (!editmode || !column.editable) {
// 						return (
// 							<td
// 								key={"I" + index + "C" + columnindex}
// 								style={column.cellstyle}
// 								className={classes.flexigridtextcontainer}
// 							>
// 								{localstate.griditems[index][column.field]}
// 							</td>
// 						)
// 					}

// 					if (editmode  && column.editable) {
// 						return (
// 							<td
// 								key={"I" + index + "C" + columnindex}
// 								style={column.cellstyle}
// 								className={classes.flexigridinputcontainer}>
// 								<input
// 									type="number" step="0.01"
// 									ref={el => rowRefs.current[index + column.field] = el}
// 									className={classes.flexigridinput}
// 									style={{ minWidth: '50px', textAlign: "right" }}
// 									onKeyDown={(event) => HandleKeyDown(event, index, column)}
// 									onKeyUp={(event) => onChangeValue(event, index, column)}
// 									onBlur={(event) => DetectBlankNumber(event, index, column)}
// 									defaultValue={localstate.defaultvalues[index][column.field]} />

// 							</td>
// 						)
// 					}
// 				}

// 				{/* ##### CHECKBOX ##### */ }
// 				if (column.render === "checkbox" && column.visible) {
// 					return (
// 						<td
// 							key={"I" + index + "C" + columnindex}
// 							style={column.cellstyle}
// 							className={classes.flexigridinputcontainer}>
// 								<Checkbox
// 									ref={el => rowRefs.current[index + column.field] = el}
// 									className={classes.gridcheckbox}
// 									disabled={(!column.editable && !editmode)}
// 									color="default"
// 									defaultChecked={localstate.defaultvalues[index][column.field] === 1 ? true : false}
// 									checkedIcon={<span className={classes.icon + " " + classes.checkedIcon} />}
// 									icon={<span className={classes.icon} />}
// 									onChange={(event) => onChangeValue(event, index, column)}
// 								/>
// 						</td>
// 					)
// 				}

// 				{/* ##### SELECT ##### */ }
// 				if (column.render === "select" && column.visible) {
// 					return (
// 						<td
// 							key={"I" + index + "C" + columnindex}
// 							style={column.cellstyle}
// 							className={classes.flexigridcustomcontainer}>
// 							<FormControl variant="standard">
// 								{/* <InputLabel id="demo-controlled-open-select-label">Optional Label</InputLabel> */}
// 								{/* Need: Set default value if row.SomeSelectable is null. */}
// 								{/* Why: Some of the values may be momentarily null for some reason - DB fetch, rerender? */}

// 								{/* Override icon prop class to our custom 'nodisplay' to remove arrowdown icon for this select */}
// 								{/* Override select prop class with new padding specs */}

// 								<Select
// 									defaultValue={
// 										localstate.defaultvalues[index][column.field] !== undefined &&
// 											localstate.defaultvalues[index][column.field] !== null
// 											? localstate.defaultvalues[index][column.field]
// 											: 0 // or null if you want no selection as the default
// 									}
// 									disableUnderline
// 									onChange={(event) => onChangeValue(event, index, column)}
// 									classes={{
// 										icon: classes.nodisplay,
// 										select: classes.selectpadding
// 									}}
// 								>
// 									{column.selectoptions.map((option, index) => {
// 										if (option.useCustomOption) {
// 											return option.customOption();
// 										} else {
// 											return (
// 												<MenuItem value={option.value}>
// 													{option.text}
// 												</MenuItem>
// 											)
// 										}


// 									})}
// 								</Select>
// 							</FormControl>
// 						</td>
// 					)
// 				}

// 				{/* ##### DATETIME ##### */ }
// 				if (column.render === "datetime" && column.visible) {
// 					return (
// 						<td style={column.cellstyle} key={"I" + index + "C" + columnindex}
// 							className={classes.flexigridtextcontainer}>
// 							<div className={classes.truncatedtextcontainer}>
// 								<div className={classes.truncatedtext}>
// 									{(column.datetimeformat === "friendly") &&
// 										<>
// 											{dayjs(localstate.griditems[index][column.field]).format("MMMM D, YYYY [at] h:mma")}
// 										</>
// 									}
// 									{(column.datetimeformat === "short") &&
// 										<>
// 											{dayjs(localstate.griditems[index][column.field]).format("M/D/YYYY h:mm A")}
// 										</>
// 									}
// 								</div>
// 							</div>
// 							{/* No tz given: <Moment element='span' format="MMMM D, YYYY [at] h:mma">{row.Date}</Moment><br></br>
// 							Localized: <Moment tz="America/New_York" element='span' format="MMMM D, YYYY [at] h:mma">{row.Date}</Moment><br></br>
// 							Bermuda: <Moment tz="Atlantic/Bermuda" element='span' format="MMMM D, YYYY [at] h:mma">{row.Date}</Moment><br></br>
// 							Los Angeles: <Moment tz="America/Los_Angeles" element='span' format="MMMM D, YYYY [at] h:mma">{row.Date}</Moment><br></br> */}
// 						</td>
// 					)
// 				}


// 				{/* ##### AUTOCOMPLETE ##### */ }
// 				if (column.render === "autocomplete" && column.visible) {
// 					return (
// 						<td
// 							key={"I" + index + "C" + columnindex}
// 							style={column.cellstyle}
// 							className={classes.flexigridinputcontainer}>
// 								<FlexiGridAutoComplete column={column} localstate={localstate} index={index} UpdateState={UpdateState} rowRefs={rowRefs} onChangeAutoCompleteValue={onChangeAutoCompleteValue} />
// 						</td>
// 					)
// 				}


// 				{/* ##### CUSTOM ELEMENT ##### */ }
// 				if (column.render === "customelement" && column.visible) {
// 					return (
// 						<React.Fragment key={"I" + index + "C" + columnindex}>
// 							{column.customelement({ localstate, index, column, classes, UpdateState, ExpandRowToggle, ResetKeys })}
// 						</React.Fragment>
// 					);
// 				}
// 				// ...handle other render types as needed
// 				return null;
// 			})}
// 		</>
// 	);
// }